import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { formatCampaignSendMethod } from '../../../../models/utils/campaignUtils';
import { baseStyleSheet } from '../../../styles/styles';

interface ISendSpeedDisplayProps {
	campaign?: Api.ICampaign;
	className?: string;
}

/**
 * Displays the send speed for a campaign (e.g., "As quickly as possible" or "Spread over X days").
 * Returns null if campaign is cancelled or send method cannot be determined.
 */
export const SendSpeedDisplay: React.FC<ISendSpeedDisplayProps> = ({ campaign, className }) => {
	// Check if campaign is cancelled first to avoid unnecessary computation
	if (campaign?.cancelledDate) {
		return null;
	}

	const sendMethodText = formatCampaignSendMethod(campaign);

	if (!sendMethodText) {
		return null;
	}

	return (
		<div className={className}>
			<span className={css(baseStyleSheet.fontBold)}>Send Speed: </span>
			<span>{sendMethodText}</span>
		</div>
	);
};
